import React from 'react';
import TextInput from '../PageBuilder/forms/TextInput';

class MenuBuilder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      items: props.items || [],
    };
  }

  handleAdd() {
    const items = [
      ...this.state.items,
      {label: '', link: '', items: []},
    ];

    this.setState({ items });
  }

  handleChangeItem(idx, field, value) {
    const items = [
      ...this.state.items.slice(0, idx),
      Object.assign({}, this.state.items[idx], { [field]: value }),
      ...this.state.items.slice(idx + 1),
    ];

    this.setState({ items });
  }

  handleDeleteItem(idx) {
    if (!confirm('Are you sure? ')) return;

    const items = [
      ...this.state.items.slice(0, idx),
      ...this.state.items.slice(idx + 1),
    ];

    this.setState({ items });
  }

  handleAddSubItem(idx) {
    const newItems = [
      ...this.state.items[idx].items,
      {label: '', link: ''},
    ];

    const items = [
      ...this.state.items.slice(0, idx),
      Object.assign({}, this.state.items[idx], { items: newItems }),
      ...this.state.items.slice(idx + 1),
    ];

    this.setState({ items });
  }

  handleChangeSubItem(idx, subIdx, field, value) {
    const newItems = [
      ...this.state.items[idx].items.slice(0, subIdx),
      Object.assign({}, this.state.items[idx].items[subIdx], { [field]: value }),
      ...this.state.items[idx].items.slice(subIdx + 1),
    ];

    const items = [
      ...this.state.items.slice(0, idx),
      Object.assign({}, this.state.items[idx], { items: newItems }),
      ...this.state.items.slice(idx + 1),
    ];

    this.setState({ items });
  }

  handleDeleteSubItem(idx, subIdx) {
    if (!confirm('Are you sure? ')) return;

    const newItems = [
      ...this.state.items[idx].items.slice(0, subIdx),
      ...this.state.items[idx].items.slice(subIdx + 1),
    ];

    const items = [
      ...this.state.items.slice(0, idx),
      Object.assign({}, this.state.items[idx], { items: newItems }),
      ...this.state.items.slice(idx + 1),
    ];

    this.setState({ items });
  }

  handleSave() {
    const { items } = this.state;
    const { save_url } = this.props;

    let self = this;
    $.ajax({
      method: 'PATCH',
      contentType: 'application/json; charset=utf-8',
      url: save_url,
      data: JSON.stringify({ items }),
      dataType: 'json',
      success: (menu) => {
        console.log(menu);
      }
    });
  }

  render() {
    const { items } = this.state;
    const { cancel_url } = this.props;

    return (
      <MenuBuilderUI
        items={items}
        cancelUrl={cancel_url}
        onAdd={() => this.handleAdd()}
        onChangeItem={(idx, field, value) => this.handleChangeItem(idx, field, value)}
        onDeleteItem={(idx) => this.handleDeleteItem(idx)}
        onAddSubItem={(idx) => this.handleAddSubItem(idx)}
        onChangeSubItem={(idx, subIdx, field, value) => this.handleChangeSubItem(idx, subIdx, field, value)}
        onDeleteSubItem={(idx, subIdx) => this.handleDeleteSubItem(idx, subIdx)}
        onSave={() => this.handleSave()}
      />
    );
  }
}

const MenuBuilderUI = ({ items, cancelUrl, onAdd, onChangeItem, onDeleteItem, onAddSubItem, onChangeSubItem, onDeleteSubItem, onSave }) => (
  <div className="menu-builder">
    <div className="menu-builder-wrapper">
      <MenuBuilderItems
        items={items}
        onChangeItem={onChangeItem}
        onDeleteItem={onDeleteItem}
        onAddSubItem={onAddSubItem}
        onChangeSubItem={onChangeSubItem}
        onDeleteSubItem={onDeleteSubItem}
      />
    </div>

    <button type="button" className="btn-primary btn-sm" onClick={onAdd}>Add menu item</button>

    <hr />

    <div className="actions">
      <button type="button" className="btn-primary" onClick={onSave}>Save</button>
      <a href={cancelUrl}>Cancel</a>
    </div>
  </div>
);

const MenuBuilderItems = ({ items, onChangeItem, onDeleteItem, onAddSubItem, onChangeSubItem, onDeleteSubItem }) => {
  if (items.length == 0) return (<p>Still no items</p>);

  return (
    <div>
      {items.map((item, idx) => <MenuBuilderItem
        key={idx}
        idx={idx}
        item={item}
        onChangeItem={(field, value) => onChangeItem(idx, field, value)}
        onDeleteItem={() => onDeleteItem(idx)}
        onAddSubItem={() => onAddSubItem(idx)}
        onChangeSubItem={(subIdx, field, value) => onChangeSubItem(idx, subIdx, field, value)}
        onDeleteSubItem={(subIdx) => onDeleteSubItem(idx, subIdx)}
      />)}
    </div>
  );
};

const MenuBuilderItem = ({ item, idx, onChangeItem, onDeleteItem, onAddSubItem, onChangeSubItem, onDeleteSubItem }) => (
  <div className="menu-builder-item">
    <div className="main-item-wrapper">
      <h4>Menu Item #{idx + 1}</h4>

      <div className="main-item">
        <TextInput
          label="Label"
          onChange={(value) => onChangeItem('label', value)}
          value={item.label}
          />
        <TextInput
          label="Link"
          onChange={(value) => onChangeItem('link', value)}
          value={item.link}
          />
        <div>
          <button type="button" className="btn-danger" onClick={onDeleteItem}>Delete</button>
        </div>
      </div>
    </div>

    <MenuBuilderSubnav
      items={item.items}
      onAddSubItem={onAddSubItem}
      onChangeSubItem={onChangeSubItem}
      onDeleteSubItem={onDeleteSubItem}
    />
  </div>
);

const MenuBuilderSubnav = ({ items, onAddSubItem, onChangeSubItem, onDeleteSubItem }) => {
  const itemNodes = items.length == 0 ? (<p>Still no items</p>) : items.map((item, idx) => <MenuBuilderSubItem key={idx} item={item} onChangeSubItem={(field, value) => onChangeSubItem(idx, field, value)} onDeleteSubItem={() => onDeleteSubItem(idx)} />);

  return (
    <div className="sub-nav">
      <h5>Submenus</h5>

      {itemNodes}

      <button type="button" className="btn-primary btn-sm" onClick={onAddSubItem}>+</button>
    </div>
  );
};

const MenuBuilderSubItem = ({ item, onChangeSubItem, onDeleteSubItem }) => (
  <div className="sub-item">
    <TextInput
      label="Label"
      onChange={(value) => onChangeSubItem('label', value)}
      value={item.label}
    />
    <TextInput
      label="Link"
      onChange={(value) => onChangeSubItem('link', value)}
      value={item.link}
    />
    <div>
      <button type="button" className="btn-danger" onClick={onDeleteSubItem}>Delete</button>
    </div>
  </div>
);

export default MenuBuilder;
